var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"max",attrs:{"data-component":"stratmk.overview.v12020"}},[_c('v-layout',{attrs:{"justify-center":"","align-center":""}},[_vm._v(" overview route ")])],1)}
var staticRenderFns = []

export { render, staticRenderFns }